import { forwardRef } from 'react';
import type { SVGIconProps } from '../types';
export const IncorrectRoleIcon = forwardRef<SVGSVGElement, SVGIconProps>(function IncorrectRoleIcon(props, ref) {
  const {
    size = 24,
    color = 'currentColor',
    className,
    ...rest
  } = props;
  return <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={size} height={size} aria-label="Incorrect Role Icon" viewBox="0 0 16 16" className={className} fill="none" {...rest}>
        <mask id={`incorrect-role-mask-${Math.random().toString(36).substr(2, 9)}`} style={{
      maskType: 'alpha'
    }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask={`url(#incorrect-role-mask-${Math.random().toString(36).substr(2, 9)})`}>
          <path d="M9.5 9.48084C8.59983 8.58067 8.07304 8.07495 6.8 8.07495M6.8 8.07495C5.52696 8.07495 4.30606 8.58067 3.40589 9.48084C2.50571 10.381 2 11.6019 2 12.875M6.8 8.07495C5.14315 8.07495 3.8 6.73181 3.8 5.07495C3.8 4.68204 4.01961 4.2642 4.18097 4.18314M5.63106 2.40682C5.95308 2.17969 6.2773 2.07494 6.80001 2.07495C8.45687 2.07495 9.80002 3.4181 9.80002 5.07495C9.80002 5.71869 9.715 6.01488 9.5981 6.31887M13.9351 8.7891L12.7348 9.9891M13.3351 9.3891L13.9351 9.9891M2.99592 2.95394L13.7109 13.669M11.3183 12.5517C11.3183 13.2145 10.781 13.7517 10.1183 13.7517C9.45557 13.7517 8.91831 13.2145 8.91831 12.5517C8.91831 11.889 9.45557 11.3517 10.1183 11.3517C10.781 11.3517 11.3183 11.889 11.3183 12.5517Z" stroke={color} strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </svg>;
});